import { Component, OnInit, AfterContentInit, AfterContentChecked, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { prebootComplete } from "angular2-universal";
import { CartService } from './cart.service';
import { ContentService } from '../shared/content.service';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { IntlService } from '../shared/intl.service';
import { isBrowser } from 'angular2-universal';

declare var $: any;
declare let paypal: any;
// declare let braintree:any;

@Component({
    template: require('./partials/cart.html'),
})
export class CartComponent implements OnInit, AfterContentInit, AfterContentChecked {

    public currentLanguage: string;
    public awayMessage: any;

    constructor(public intl: IntlService, private config: ConfigService, private contentService: ContentService, private elementRef: ElementRef, private utils: UtilsService, public cartService: CartService, private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        // Current language
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
            }
        );
        this.contentService.getContent('message',{label: 'away'}, true) // true = no cache
        .then(res => {
            this.awayMessage = res;
        });
    }

    ngAfterContentInit() {
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof prebootComplete != 'undefined') {
            prebootComplete();
        }
    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }     
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cart.component.ts